import _page from './core--object-page';
import _bp from './base/base--breakpoint';
import libraryArrays from '../library/library--array';
import libraryUtils from '../library/library--utils';
import libraryjQuery from '../library/library--jquery';

class _Base {
    constructor() {}
}
_Base.prototype._page = _page;
_Base.prototype._bp = _bp;
_Base.prototype._library = {
    _array: libraryArrays,
    _utils: libraryUtils,
    _$: libraryjQuery
};
_Base.prototype._library._array = libraryArrays;

const _g = new _Base();

export { _g };
export default _Base;
